import { SET_ITEMS } from '../mutation-types'
import axios from 'axios'

const CLEAR = 'CLEAR'

export default {
    namespaced: true,

    state: {
        data: [],
        chart: []
    },

    getters: {
        //
    },

    mutations: {
        [SET_ITEMS](state, { data }) {
            state.data = data.sales
            state.chart = data.chart
        },
        [CLEAR](state) {
            state.data = []
            state.chart = []
        }
    },

    actions: {
        async fetchAll({ commit }, { params }) {
            try {
                let response = await axios.get('api/reports/sales', { params: { ...params } })
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }

            return true
        }
    }
}
